export default function ApprovePRAProcessDialogController(
  $filter,
  $rootScope,
  $q,
  $timeout,
  alerts,
  ssDialogService,
  loaderService,
  praDataService,
  praSharedModelService,
  assetSharedModelService
) {
  const vm = this;

  vm.handleCloseDialog = _handleCloseDialog;
  vm.handleNavToProcess = _handleNavToProcess;
  vm.handleApprovePRAProcessFormSubmit = _handleApprovePRAProcessFormSubmit;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    vm.processes = angular.copy(vm._processes);
    _sortProcesses();
    if (!vm.activeProcess) {
      vm.activeProcess = $filter('filter')(vm.processes, {
        status: 'AwaitingApproval',
      }, true)[0];
      getAssignedAssets();
    } else {
      const pos = vm.processes.findIndex(item => item.assessmentProcessId === vm.activeProcess.assessmentProcessId);
      if (pos === -1) return; // Can't find the item
      vm.activeProcess = vm.processes[pos];
      getAssignedAssets();
    }
  }

  function _handleCloseDialog() {
    ssDialogService.hide(ssDialogService.dialogs.pra.approvePRAProcessDialog);
  }

  function _handleNavToProcess(processId) {
    const newActiveProcess = $filter('filter')(vm.processes, {
      processId,
    }, true)[0];

    if (vm.activeProcess.assessmentProcessId !== newActiveProcess.assessmentProcessId) {
      vm.contentPaneIsFaded = true;
      $timeout(
        () => {
          vm.activeProcess = newActiveProcess;
          getAssignedAssets();
          vm.contentPaneIsFaded = false;
        },
        120
      );
    }
  }

  function getAssignedAssets() {
    if (!vm.activeProcess.assetIsLoaded) {
      loaderService.showViewLoader = true;
      const promises = [
        praDataService.getProcessAssetsByType(vm.activeProcess.assessmentProcessId),
        praSharedModelService._initPage(),
      ];
      return $q.all(promises)
        .then((response) => {
          try {
            loaderService.showViewLoader = false;
            vm.activeProcess = response[0].data;
            vm.activeProcess.assetIsLoaded = true;
            initRiskAppetite();
            vm.assignedAssets = vm.activeProcess.assessment.assessmentCustomerAssets;
            vm.assetTypes = angular.copy(assetSharedModelService.AssetTypes);
            // eslint-disable-next-line max-len
            vm.activeProcess.allAssignedAssets = praDataService.transformAssignedAssets(vm.assignedAssets, vm.assetTypes);
            // eslint-disable-next-line max-len
            const pos = vm.processes.findIndex(item => item.assessmentProcessId === vm.activeProcess.assessmentProcessId);
            if (pos === -1) return; // Can't find the item
            vm.processes[pos] = vm.activeProcess;
          } catch (error) {
            console.error(error);
          }
        })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }


  function initRiskAppetite() {
    if (vm.activeProcess.customerRiskAppetiteLevelId) {
      const _riskAppetiteLevel = praSharedModelService.customerRiskAppetiteLevels.find(
        riskAppetiteLevel => riskAppetiteLevel.customerRiskAppetiteLevelID
          === vm.activeProcess.customerRiskAppetiteLevelId
      ).riskAppetiteLevel;
      vm.activeProcess.riskAppetiteName = _riskAppetiteLevel.name;
      vm.activeProcess.riskAppetiteDisplayName = _riskAppetiteLevel.name.replace(' Risk', '');
      vm.activeProcess.riskAppetiteLevelId = _riskAppetiteLevel.riskAppetiteLevelId;
      vm.activeProcess.riskAppetiteCssClass = praSharedModelService
        .riskAppetiteClassMappings[vm.activeProcess.riskAppetiteLevelId];
    } else {
      vm.activeProcess.riskAppetiteName = 'Not Set';
      vm.activeProcess.riskAppetiteLevelId = null;
      vm.activeProcess.riskAppetiteCssClass = praSharedModelService
        .riskAppetiteClassMappings[vm.activeProcess.riskAppetiteLevelId];
    }
  }

  // function _resetContentPaneScroll() {
  //   angular.element(
  //       '.bcp--approve-impact-analysis-content-pane'
  //   )[0].scrollTop = 0;
  // }

  function _handleApprovePRAProcessFormSubmit() {
    loaderService.showViewLoader = true;
    const affectedProcesses = [];
    angular.forEach(vm.processes, (currentProcess) => {
      if (currentProcess.approved !== undefined) {
        const process = {
          assessmentProcessId: currentProcess.assessmentProcessId,
          isApproved: currentProcess.approved,
          denialNotes: currentProcess.denialNotes,
        };
        affectedProcesses.push(process);
      }
    });

    praDataService.approveOrDenyProcesses(affectedProcesses).then(
      () => {
        alerts.success('The Process(es) have been approved/denied successfully.');
        ssDialogService.hide(ssDialogService.dialogs.pra.approvePRAProcessDialog);
        $rootScope.$broadcast('refreshMainAssessment');
        loaderService.showViewLoader = false;
      },
      () => {
        alerts.error('The approval/denial of the Process(es) has failed.');
        loaderService.showViewLoader = false;
      }
    );
  }

  function _sortProcesses() {
    const sortL = function (a, b) {
      const nameA = a.name.toLowerCase(); // ignore upper and lowercase
      const nameB = b.name.toLowerCase(); // ignore upper and lowercase
      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }

      // names must be equal
      return 0;
    };
    vm.processes.sort(sortL);
  }
}

ApprovePRAProcessDialogController.$inject = [
  '$filter',
  '$rootScope',
  '$q',
  '$timeout',
  'alerts',
  'ssDialogService',
  'loaderService',
  'praDataService',
  'praSharedModelService',
  'assetSharedModelService'
];
